import React from "react";
import NewsletterSix from "../component/NewsletterSix";

function NewsletterSixContainers() {
  return <NewsletterSix />;
}

export default NewsletterSixContainers;
